module.exports = __webpack_public_path__ + "img/login.e2be0bd1.svg";